import React from 'react';

import { Modal } from 'src/components/common';
import { TestVerificationRequestCreateModalForm } from 'src/components/testVerificationRequest';
import { ModalId } from 'src/constants/modals';
import { useModal } from 'src/hooks/shared';

export const TestVerificationRequestCreateModal: React.FC = () => {
  const { closeModal, switchClosability, isOpen } = useModal(
    ModalId.TestVerificationRequestCreateModal,
  );

  const handleCloseModal = React.useCallback(() => {
    closeModal();
  }, [closeModal]);

  return (
    <Modal
      title="Create New Test Verification Request"
      dialogProps={{
        onClose: handleCloseModal,
        open: isOpen,
      }}
    >
      <TestVerificationRequestCreateModalForm
        closeModal={handleCloseModal}
        switchClosability={switchClosability}
      />
    </Modal>
  );
};
